// import React from 'react'
// import ReactDOM from 'react-dom'
import { split, ApolloLink } from 'apollo-link'
import { ApolloClient } from 'apollo-client'
import { WebSocketLink } from 'apollo-link-ws'
import { getMainDefinition } from 'apollo-utilities'
import { setContext } from 'apollo-link-context'
import { onError } from 'apollo-link-error'
import { createUploadLink } from 'apollo-upload-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { Modal } from 'antd'
import { getAccessToken, getURL, removeAccessToken } from './utils/local-data-service'
import URL from './constants/environment'

const errorCode = {
  FORBIDDEN: 500,
  UNAUTHENTICATED: 401,
}

let modalHandleStatus = false

console.info({
  ...process.env,
})

const url = process.env.REACT_APP_BUILD_MODE === 'production' ? URL.production : (process.env.REACT_APP_BUILD_MODE === 'staging') ? URL.staging : URL.development

const token = getAccessToken()
const NETWORK_INTERFACE_URL = token ? url.GRAPH_PRIVATE : url.GRAPH_PUBLIC

console.info('////////////')
console.info(NETWORK_INTERFACE_URL)
console.info('/////////////')

const SUBSCRIPTION_CLIENT_URL = 'wss://subscriptions.graph.cool/v1/API_KEY'

const authLink = setContext((_, { headers }) => ({
  headers: {
    ...headers,
    authorization: token ? `Bearer ${token}` : '',
  },
}))

const uploadLink = createUploadLink({
  uri: NETWORK_INTERFACE_URL,
})


// Create a WebSocket link:
const wsLink = new WebSocketLink({
  uri: SUBSCRIPTION_CLIENT_URL,
  options: {
    // reconnect: true,
  },
})

// using the ability to split links, you can send data to each link
// depending on what kind of operation is being sent
const link = split(
  // split based on operation type
  ({ query }) => {
    const { kind, operation } = getMainDefinition(query)
    return kind === 'OperationDefinition' && operation === 'subscription'
  },
  wsLink,
  authLink.concat(uploadLink),
)

// const client = new ApolloClient({
//   link,
//   cache: new InMemoryCache(),
// })

const client = new ApolloClient({
  link: ApolloLink.from([
    onError(({
      graphQLErrors, networkError,
    }) => {
      console.error(graphQLErrors)
      console.error(networkError)
      switch (graphQLErrors[0].statusCode) {
        case errorCode.FORBIDDEN:
        {
          if (!modalHandleStatus) {
            modalHandleStatus = !modalHandleStatus
            Modal.error({
              title: graphQLErrors[0].message,
              content: 'code: 1',
              onOk() {
                modalHandleStatus = !modalHandleStatus
                window.location = `${getURL().WEB_SERVER}/`
              },
            })
            console.error('FORBIDDEN')
          }
          break
        }
        case errorCode.UNAUTHENTICATED:
        {
          Modal.error({
            title: graphQLErrors[0].message,
            content: 'code: 2',
            onOk() {
              modalHandleStatus = !modalHandleStatus
              removeAccessToken()
              window.location = `${getURL().WEB_SERVER}/`
            },
          })
          console.error('UNAUTHENTICATED')
          break
        }
        default:
        {
          Modal.error({
            title: graphQLErrors[0].message,
            content: 'code: 0',
            onOk() {
              window.location = `${getURL().WEB_SERVER}/`
            },
          })
          break
        }
      }
    }),
    link,
  ]),
  cache: new InMemoryCache(),
  ssrForceFetchDelay: 100,
  defaultOptions: {
    query: {
      errorPolicy: 'all',
    },
    mutate: {
      errorPolicy: 'all',
    },
  },
})

export default client
